import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InternalLayoutComponent } from '../layouts';
import { AuthGuard } from 'app/shared/auth/services';
import { SharedLayoutMainComponent } from '../shared';
import { UserSettingsComponent } from './pages/user-settings/user-settings.component';

export const routes: Routes = [
  {
    path: 'useraccount',
    component: InternalLayoutComponent,
    canActivate: [AuthGuard],
    data: { roles: [] },
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'user-settings',
        component: SharedLayoutMainComponent,
        children: [
          { path: '', component: UserSettingsComponent, title: 'User Settings' },
        ]
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserSettingsRoutingModule { }
